import { Crown, Gem, MapPin, CalendarDays } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { scrollTo } from "@/lib/lenis";
import { IMAGES } from "@/lib/site";

const cards = [
  {
    id: "treasure-queen",
    icon: Crown,
    title: "TREASURE QUEEN",
    desc: "For aspiring female pageant participants ready to claim the crown.",
    img: IMAGES.queen,
    alt: "Elegant woman wearing a pageant crown and gown",
    pos: "center",
  },
  {
    id: "treasure-king",
    icon: Gem,
    title: "TREASURE KING",
    desc: "For aspiring male pageant participants born for the spotlight.",
    img: IMAGES.king,
    alt: "Confident man in a premium black tuxedo",
    pos: "center 22%",
  },
];

export default function FeaturedEvent() {
  return (
    <section id="featured-event" className="relative py-28 lg:py-36 bg-royal-900/40 border-y border-gold/10 spotlight-fuchsia" data-testid="featured-event-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading
          eyebrow="Featured Event"
          title={<>TREASURE QUEEN <span className="gold-text italic">&</span> KING 2026</>}
          sub="A Celebration of Beauty • Confidence • Personality • Talent"
          testId="featured-event-heading"
        />

        <Reveal className="flex justify-center -mt-6 mb-14">
          <div className="glass-card rounded-full px-8 py-3 flex items-center gap-6 text-sm" data-testid="featured-event-badge">
            <span className="flex items-center gap-2 text-gold"><MapPin size={16} /> Pune</span>
            <span className="w-px h-4 bg-gold/30" />
            <span className="flex items-center gap-2 text-gold"><CalendarDays size={16} /> November 2026</span>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {cards.map((c, i) => (
            <Reveal key={c.id} delay={0.15 * i}>
              <article
                id={c.id}
                className="group relative overflow-hidden rounded-md gold-frame h-[540px] cursor-pointer scroll-mt-28"
                onClick={() => scrollTo("#register")}
                data-testid={`${c.id}-card`}
              >
                <img
                  src={c.img}
                  alt={c.alt}
                  style={{ objectPosition: c.pos }}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-royal-950 via-royal-950/35 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-8 lg:p-10">
                  <c.icon className="text-gold mb-4 transition-transform duration-500 group-hover:-translate-y-1" size={34} />
                  <h3 className="font-display text-3xl lg:text-4xl font-bold tracking-wide gold-text">{c.title}</h3>
                  <p className="mt-3 text-cream/80 text-sm max-w-sm">{c.desc}</p>
                  <button
                    className="mt-6 rounded-full border border-gold/60 px-7 py-2.5 text-xs font-semibold tracking-widest text-gold transition-all duration-300 group-hover:bg-gold group-hover:text-royal-950"
                    data-testid={`${c.id}-participate-btn`}
                  >
                    PARTICIPATE NOW
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
